import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const ConferencePhotos = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const getConferenceIdFromUrl = () => {
    const pathParts = location.pathname.split("/").filter(Boolean);
    return pathParts[pathParts.length - 1];
  };

  useEffect(() => {
    const conferenceId = getConferenceIdFromUrl();

    if (!conferenceId) {
      setError("Conference ID not found in URL");
      setLoading(false);
      return;
    }

    const fetchConferencePhotos = async () => {
      try {
        setLoading(true);
        setError("");

        const res = await axios.get(
          `https://eventscons.com/eventbackendnew/api/cphotos/${conferenceId}`
        );

        const apiData = res?.data?.data || [];
        const normalizedData = Array.isArray(apiData) ? apiData : [];

        setPhotos(normalizedData.slice(0, 10));
      } catch (err) {
        console.error("Conference photos API error:", err);
        setError("Failed to load conference photos");
      } finally {
        setLoading(false);
      }
    };

    fetchConferencePhotos();
  }, [location.pathname]);

  const getImage = (item) => {
    return (
      item?.photo_url ||
      item?.image_url ||
      "https://via.placeholder.com/300x200?text=Conference+Photo"
    );
  };

  const getTitle = (item, index) => {
    return item?.title || item?.name || `Conference Photo ${index + 1}`;
  };

  const conferenceId = getConferenceIdFromUrl();

  return (
    <>
      <style>
        {`
          .conference-photos-section {
            max-width: 90%;
            margin: 40px auto;
            
          }

          .conference-photos-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 18px;
          }

          .conference-photos-header h2 {
            margin: 0;
            font-size: 20px;
            font-weight: 700;
            color: #111;
          }

          .view-all-btn {
            background: #000;
            color: #fff;
            border: none;
            outline: none;
            border-radius: 30px;
            padding: 10px 22px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
          }

          .divider {
            height: 1px;
            background: #cfcfcf;
            margin-bottom: 28px;
          }

          .conference-photos-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 20px 16px;
          }

          .conference-photo-card {
            width: 100%;
            height: 200px;
            border-radius: 14px;
            overflow: hidden;
            border: 1.5px solid #a1264d;
            background: #fff;
            box-sizing: border-box;
          }

          .conference-photo-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
          }

          .status-text {
            text-align: center;
            font-size: 14px;
            color: #444;
            padding: 20px 0;
          }

          .error-text {
            color: red;
          }

          @media (max-width: 480px) {
            .conference-photos-section {
              padding: 18px;
            }

            .conference-photos-grid {
              gap: 16px 12px;
            }

            .conference-photo-card {
              height: 130px;
            }

            .view-all-btn {
              padding: 8px 18px;
              font-size: 13px;
            }
          }
        `}
      </style>

      <section className="conference-photos-section">
        <div className="conference-photos-header">
          <h2>PHOTOS</h2>
          
        </div>

        <div className="divider" />

        {loading ? (
          <p className="status-text">Loading photos...</p>
        ) : error ? (
          <p className="status-text error-text">{error}</p>
        ) : photos.length === 0 ? (
          <p className="status-text">No photos found.</p>
        ) : (
          <div className="conference-photos-grid">
            {photos.map((item, index) => (
              <div className="conference-photo-card" key={item?.id || index}>
                <img
                  src={getImage(item)}
                  alt={getTitle(item, index)}
                  className="conference-photo-img"
                  onError={(e) => {
                    e.target.src =
                      "https://via.placeholder.com/300x200?text=Conference+Photo";
                  }}
                />
              </div>
            ))}
          </div>
        )}
      </section>
    </>
  );
};

export default ConferencePhotos;